import DashBoardPage from "./dashboard-page" ;

export default DashBoardPage 